import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface MidChapterCTAProps {
  hookText: string;
  buttonText?: string;
  className?: string;
}
export function MidChapterCTA({
  hookText,
  buttonText = 'Obtener Acceso',
  className = ''
}: MidChapterCTAProps) {
  return <div className={`px-4 py-8 ${className}`} data-id="element-154">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-50px'
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto bg-[#1a2744]/40 backdrop-blur-md border border-[#d4a843]/40 rounded-xl p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6 shadow-[0_0_20px_rgba(212,168,67,0.1)] hover:shadow-[0_0_30px_rgba(212,168,67,0.2)] transition-shadow duration-300" data-id="element-155">
        <div className="flex-1 text-center md:text-left" data-id="element-156">
          <h3 className="text-xl md:text-2xl font-serif text-white leading-tight" data-id="element-157">
            {hookText}
          </h3>
        </div>

        <motion.button whileHover={{
        scale: 1.05,
        backgroundColor: '#e8c66a'
      }} whileTap={{
        scale: 0.95
      }} onClick={() => {
        document.getElementById('precio')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} className="flex-shrink-0 bg-[#d4a843] text-[#0a1628] px-8 py-3 rounded-lg font-bold text-lg shadow-lg flex items-center gap-2 group" data-id="element-158">
          {buttonText}
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-159" />
        </motion.button>
      </motion.div>
    </div>;
}